exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-container {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    background-color: #F2F2F1;\r\n    min-height: 400px;\r\n    /* margin: 10px 0; */\r\n}\r\n\r\n.card-container {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    margin: auto;\r\n    width: 50%;\r\n}\r\n\r\n.title {\r\n    font-family: verdana;\r\n    font-size: 5em;\r\n    color: #23527C;\r\n    margin: 40px 0 10px 0;\r\n    font-weight: bold;\r\n}\r\n\r\n.left {\r\n    padding-right: 80px\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/dev/Perso/urmeo/src/app/home/home.component.css
// module id = ../../../../../src/app/home/home.component.css
// module chunks = main